module.exports = __webpack_public_path__ + "img/PM_A01_front_fr.6822aa7a.png";